module.exports = __webpack_public_path__ + "static/media/insta-01.9ed6d5cc.jpg";